<app-header [sub_titulo]="'Feriados'" [todas_opciones]="false"></app-header>
<!-- Panel izquierda -->
<mat-card style="background-color: #f8f8ff; width: 100%; height: auto">
  <div id="menus" style="min-height: 95vh; height: auto">
    <div
      class="card-body-content"
      style="width: 99%; min-height: 90%; max-height: 99%; height: 90%"
    >
      <br />
      <mat-card style="height: 99%">
        <div class="feriado-manager">
          <form (ngSubmit)="addFeriados()" #formFeriado="ngForm">
            <div class="form-box">
              <div class="form-group">
                <div class="css-Campo_Default campo_default">
                  <p class="css-Etiqueta etiqueta">Fecha</p>
                  <div class="css-Campo_mensaje campo_mensaje">
                    <mat-form-field
                      appearance="outline"
                      class="campo-fecha-custom"
                    >
                      <input
                        matInput
                        [matDatepicker]="picker"
                        placeholder="Elegir fecha"
                        [(ngModel)]="selectedDate"
                        (ngModelChange)="validateForm()"
                      />
                      <mat-datepicker-toggle
                        matSuffix
                        [for]="picker"
                      ></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>

                    <div
                      class="css-mensaje_error mensaje_error error-off"
                      *ngIf="mensaje_error_fecha.length > 0"
                    >
                      <div class="css-Icono_Error_Forms-1 icono_error_forms">
                        <img
                          src="assets/images/basecomponents-images/campo-default.svg"
                          width="9px"
                          height="9px"
                          class="css-close close"
                        />
                      </div>
                      <p class="css-Texto-1 texto">{{ mensaje_error_fecha }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <app-campo-default-admin
                descripcion_etiqueta="Descripción"
                placeholder_input=""
                [(ngModel)]="nombre"
                [mensaje_error]="mensaje_error_descripcion"
              >
              </app-campo-default-admin>

              <div class="container-add-btn">
                <button
                  class="add-btn"
                  type="submit"
                  [disabled]="!formFeriado.form.valid"
                  title="Agregar feriado a la lista"
                >
                  Agregar a la lista
                </button>
              </div>
            </div>
          </form>

          <div
            class="table-box"
            *ngIf="
              feriadosTemporales.length > 0 || feriadosBD.content.length > 0
            "
          >
            <app-boton-primario
              boton_texto="Duplicar"
              (boton_funcion)="duplicar()"
              clase="blue"
            ></app-boton-primario>
            <h3>Feriados agregados:</h3>

            <table>
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Descripción</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let feriado of paginatedFeriados; let i = index">
                  <td>{{ feriado.fecha | date : "dd/MM/yyyy" }}</td>
                  <td>{{ feriado.descripcion || feriado.nombre }}</td>
                  <td>
                    <button
                      class="icon-btn edit"
                      (click)="
                        editarFeriado(
                          i + (currentPage - 1) * pageSize,
                          feriado.tipo
                        )
                      "
                    >
                      <img
                        src="assets/images/admin-asistente-images/EditYellow.png"
                        width="17.5px"
                      />
                    </button>
                    <button
                      class="icon-btn delete"
                      (click)="
                        deleteFeriados(
                          i + (currentPage - 1) * pageSize,
                          feriado.tipo
                        )
                      "
                    >
                      <img
                        src="assets/images/admin-asistente-images/TrashRed.png"
                        width="17.5px"
                      />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div>
              <mat-paginator
                [length]="getAllFeriados().length"
                [pageSize]="pageSize"
                [pageIndex]="currentPage - 1"
                [pageSizeOptions]="[5, 10, 25, 100]"
                (page)="onPageChange($event)"
                showFirstLastButtons
              >
              </mat-paginator>
            </div>
            <div class="feriado-fin">
              <app-boton-primario
                [boton_texto]="loading ? 'Guardando' : 'Guardar'"
                (boton_funcion)="saveFeriados()"
                [spinner]="loading"
                titulo="Aplicar cambios en feriados"
              ></app-boton-primario>
              <button mat-raised-button  (click)="volver()">Cancelar</button> 
            </div>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</mat-card>
